import React, { useState, useCallback, useEffect, useRef } from 'react'
import LayoutWithOutAccountCard from '../../Layout/layout-without-card'
import FooterServices from '../../../services/footer.service'
import Loading from 'custom/assets/loaders/Loading'
import AuthLayout from '../auth-layout'
import { useHistory } from 'react-router-dom'
import { LANDING_EXCHANGE_RATE_KEYS , BUTTON_KEYS} from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next';

export default function ExchangeRates() {
  const [exchangeDetails, setExchangeDetails] = useState([])
  const [stage, setStage] = useState(0)
  const history = useHistory()
  const {t}=useTranslation()

  useEffect(() => {
    getExchangeRatesDetails()
  }, [])

  const getExchangeRatesDetails = useCallback(async (values) => {
    try {
      setStage(0)
      const response = await FooterServices.getExchangeRatesDetails(values)
      if (response.status === 200) {
        setExchangeDetails(response.data['crossCurRateList'])
        setStage(1)
      }
    } catch (err) {
      setStage(1)
      console.error(err)
    }
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderExchangeRatesForm()
      default:
        return renderLoading()
    }
  }

  function renderExchangeRatesForm() {
    return (
      <div>
        <div>
          <div className='heading5'>
            <div className='headingCell5'>{t(LANDING_EXCHANGE_RATE_KEYS.CONVERSION_TYPE)}</div>
            <div className='headingCell5'>{t(LANDING_EXCHANGE_RATE_KEYS.BUY_PRICE)}</div>
            <div className='headingCell5'>{t(LANDING_EXCHANGE_RATE_KEYS.SELL_PRICE)}</div>
          </div>
          {exchangeDetails.map((item, index) => (
            <div className='row5' key={index}>
              <div className='cell5'>{item.symbol}</div>
              <div className='cell5'>{item.buyRate}</div>
              <div className='cell5'>{item.saleRate}</div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <AuthLayout>
      {exchangeDetails.length === 0 && renderLoading()}
      {exchangeDetails.length > 0 && (
        <div className='mt-5'>
          <div className=' small font-weight-600'>
            <div className=''>{renderSwitch()}</div>
            <div className='my-4' />
            <div className='row text-center d-flex justify-content-center '>
              <button
                tabIndex={'1'}
                onClick={() =>
                  history.push({
                    pathname: '/landing',
                  })
                }
                className='btn btn-sm btn-link small new-design-warning-text-color font-weight-600 mb-5'>
                {t(BUTTON_KEYS.BACK)}
              </button>
            </div>
          </div>
        </div>
      )}
    </AuthLayout>
  )
}
